export const validateCuit = cuitOrCuil => {
    if (!/^\d{2}-\d{8}-\d$/.test(cuitOrCuil)) {
        return false;
    }

    var cuitOrCuilNoDash = cuitOrCuil.replace(/-/g, '');
    var checkDigit = parseInt(cuitOrCuilNoDash.charAt(10));
    var checkSum = 0;
    var multiplier = [5, 4, 3, 2, 7, 6, 5, 4, 3, 2];

    for (var i = 0; i < 10; i++) {
        checkSum += parseInt(cuitOrCuilNoDash.charAt(i)) * multiplier[i];
    }

    var result = (11 - (checkSum % 11)) % 11;
    return result === checkDigit;
};
